/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CsvImportConfigDto } from '../models/CsvImportConfigDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CsvImportConfigControllerService {
    /**
     * @param uuid
     * @returns CsvImportConfigDto OK
     * @throws ApiError
     */
    public static findByUuid(
        uuid: string,
    ): CancelablePromise<CsvImportConfigDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/csv-import-configs/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param requestBody
     * @returns CsvImportConfigDto OK
     * @throws ApiError
     */
    public static update(
        uuid: string,
        requestBody: CsvImportConfigDto,
    ): CancelablePromise<CsvImportConfigDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/csv-import-configs/{uuid}',
            path: {
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns any OK
     * @throws ApiError
     */
    public static delete(
        uuid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/csv-import-configs/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @returns CsvImportConfigDto OK
     * @throws ApiError
     */
    public static findAll(): CancelablePromise<Array<CsvImportConfigDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/csv-import-configs',
        });
    }
    /**
     * @param requestBody
     * @returns CsvImportConfigDto OK
     * @throws ApiError
     */
    public static create(
        requestBody: CsvImportConfigDto,
    ): CancelablePromise<CsvImportConfigDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/csv-import-configs',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param entityType
     * @returns CsvImportConfigDto OK
     * @throws ApiError
     */
    public static getConfigByEntityType(
        entityType: string,
    ): CancelablePromise<CsvImportConfigDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/csv-import-configs/entity-type/{entityType}',
            path: {
                'entityType': entityType,
            },
        });
    }
}
